var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76474 7.16685C7.19818 7.60029 7.19818 8.34333 6.76474 8.77677L5.8669 9.67461C5.43346 10.108 4.69043 10.108 4.25699 9.67461L0.325079 5.71174C-0.10836 5.2783 -0.10836 4.53526 0.325079 4.10182L1.22292 3.20399C1.65636 2.77055 2.39939 2.77055 2.83283 3.20399L6.76474 7.16685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2017 0.325079C10.6351 -0.10836 11.3782 -0.10836 11.8116 0.325079L12.7094 1.22292C13.1429 1.65635 13.1429 2.39939 12.7094 2.83283L5.89826 9.61305C5.46482 10.0465 4.72178 10.0465 4.28835 9.61305L3.39051 8.71521C2.95707 8.28177 2.95707 7.53874 3.39051 7.1053L10.2017 0.325079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBold);
export default __webpack_public_path__ + "static/media/checkboxBold.6872bd26b592e1587109a2dfeeb2c3f7.svg";
export { ForwardRef as ReactComponent };